"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoNames = void 0;
var GazetteerSearchType_1 = require("../GazetteerSearchType");
var GazetteerBase_1 = require("../GazetteerBase");
var olProj = require("ol/proj");
var olExtent = require("ol/extent");
var GeoNames = /** @class */ (function (_super) {
    __extends(GeoNames, _super);
    function GeoNames(_map, _textPack, _zoomToLevel, _elementId, _btnCssClass, _iconCssClass, _clearerCssClass) {
        if (_zoomToLevel === void 0) { _zoomToLevel = 15; }
        if (_elementId === void 0) { _elementId = "gazetteer"; }
        if (_btnCssClass === void 0) { _btnCssClass = "btn btn-primary"; }
        if (_iconCssClass === void 0) { _iconCssClass = "fa fa-search"; }
        if (_clearerCssClass === void 0) { _clearerCssClass = "fa fa-times"; }
        var _this = _super.call(this, _map, _textPack, null, _elementId, _btnCssClass, _iconCssClass, _clearerCssClass) || this;
        _this._zoomToLevel = _zoomToLevel;
        _this._geoNamesInitialised = false;
        _this.init = function () {
            if (!_this._geoNamesInitialised) {
                //strip-loader should take this out for production
                console.log("Initialising geonames");
                _this._geoNamesInitialised = true;
            }
        };
        _this.find = function (searchTerm) {
            var searchType = _this.getSearchType(searchTerm);
            if (searchTerm.trim() === "") {
                return;
            }
            switch (searchType) {
                case GazetteerSearchType_1.GazetteerSearchType.Postcode:
                    _this.findPostcode(searchTerm);
                    break;
                case GazetteerSearchType_1.GazetteerSearchType.Location:
                    _this.findLocation(searchTerm);
                    break;
            }
        };
        _this.findPostcode = function (searchTerm) {
            _this.searchGazetteer({
                url: "/api/GeoNames/PostCode",
                postalcode: searchTerm
            });
        };
        _this.findLocation = function (searchTerm) {
            _this.searchGazetteer({
                url: "/api/GeoNames/Location",
                name_startsWith: searchTerm
            });
        };
        _this.searchGazetteer = function (params) {
            var self = _this;
            var url = params.url;
            delete params.url;
            self.loadingIndicator.show();
            $.ajax({
                url: url,
                data: params,
                success: function (e) {
                    try {
                        self.onSearchGazetteerResult(e);
                    }
                    catch (err) {
                        self.loadingIndicator.hide();
                        console.error(err);
                    }
                },
                dataType: "json"
            }).always(function () {
                self.loadingIndicator.hide();
            });
        };
        _this.onSearchGazetteerResult = function (e) {
            if (e.geonames && e.geonames.length > 0) {
                //one or more matches - placename search
                _this.processSearchResult(e.geonames, _this._zoomToLevel);
            }
            else if (e.postalCodes && e.postalCodes.length > 0) {
                //one or more matches - postcode search
                _this.processSearchResult(e.postalCodes, _this._zoomToLevel);
            }
            else {
                _this.resultsSelect.empty();
                _this.resultsSelect.append("<option>".concat(_this._textPack.noResultsFound, "</option>"));
                _this.noResults.show();
            }
        };
        _this.processSearchResult = function (matches, zoomToLevel) {
            var self = _this;
            var locations = new Array(), location;
            //remove all existing entries      
            self.resultsSelect.empty();
            self.resultsSelect.hide();
            self.noResults.hide();
            var mapExtent = self._map.options.extent;
            for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
                var m = matches_1[_i];
                //transform fails if there are only a few decimal places in the result coords, force value to a float
                var coord3857 = olProj.transform([parseFloat(m.lng), parseFloat(m.lat)], "EPSG:4326", self.displayProjection);
                if (!mapExtent || olExtent.containsCoordinate(mapExtent, coord3857) === true) {
                    location = {
                        Easting: coord3857[0],
                        Northing: coord3857[1],
                        Name: m.name || m.postalCode,
                        ZoomLevel: zoomToLevel
                    };
                    if (m.adminName2) {
                        location.Name += " (".concat(m.adminName2, ")");
                    }
                    locations.push(location);
                }
            }
            self.searchResults = new Array();
            if (locations.length === 0) {
                self.resultsSelect.append("<option>".concat(_this._textPack.noResultsFound, "</option>"));
                self.noResults.show();
            }
            else if (locations.length > 1) {
                //add empty option
                self.resultsSelect.append("<option>".concat(_this._textPack.selectFromResults, "</option>"));
                for (var i = 0; i < locations.length; i++) {
                    self.resultsSelect.append("<option data-result-index=\"".concat(i, "\">").concat(locations[i].Name, "</option>"));
                    self.searchResults.push(locations[i]);
                }
                self.resultsSelect.show();
            }
            else if (locations.length === 1) {
                var coord3857 = [locations[0].Easting, locations[0].Northing];
                self.addPinAndCenterMap(coord3857, zoomToLevel);
            }
        };
        _this.getSearchType = function (searchTerm) {
            if (/\d/.test(searchTerm)) { //If the search term has numeric characters then it's not a placename
                return GazetteerSearchType_1.GazetteerSearchType.Postcode;
            }
            else {
                return GazetteerSearchType_1.GazetteerSearchType.Location;
            }
        };
        _this.init();
        return _this;
    }
    return GeoNames;
}(GazetteerBase_1.GazetteerBase));
exports.GeoNames = GeoNames;
//# sourceMappingURL=GeoNames.js.map